export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref10711.b5da8d35.jpg";